import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import { Button, CardActions, FormControl, Grid, TextField } from '@mui/material';
import { useState } from 'react';

function UnclearSignatureCard({ onSubmit, docType }) {
    const [fullName, setFullName] = useState('');
    const [position, setPosition] = useState('');
    const [error, setError] = useState(false);
    const handleSave = () => {
        if (fullName && position) {
            onSubmit({ fullName, position });
        } else {
            alert('Lütfen tüm alanları doldurun.');
        }
    };

    return (
        <JumboCardQuick>
            <Grid container spacing={2} mb={1}>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <TextField
                            label="Yetkili [Ünvan Ad Soyad]"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            required
                            error={error}
                            helperText={error ? "Bu alan zorunludur" : ""}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <TextField
                            label="Makam"
                            value={position}
                            onChange={(e) => setPosition(e.target.value)}
                            error={error} // Hata durumunda kırmızı çerçeve eklenir
                            helperText={error ? "Bu alan zorunludur" : ""}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>

            <CardActions sx={{ justifyContent: 'center' }}>
                <Button
                    variant="outlined"
                    size="large"
                    color="success"
                    onClick={handleSave}
                >
                    {docType === "pdf" ? "PDF'E AKTAR" : "WORD'e AKTAR"}
                </Button>
            </CardActions>
        </JumboCardQuick>
    );
}

export default UnclearSignatureCard;
